import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Accordion, AccordionSummary, AccordionDetails, useMediaQuery, useTheme, Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getNumberComma } from '../../utils/numberUtils';
import { useLocation , useNavigate } from 'react-router-dom';

const ChanceTotalSummary = ({ totals }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isForeCast = (location.pathname === '/chancemng' ? true : false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleAddForecast = () => {
    navigate('/chancemng/addForecast');
  };

  const summaryData = [
    { label: '총매출액', value: totals?.sales },
    { label: '정산전 매출이익', value: totals?.salesProfitBefore },
    { label: '협업이익', value: totals?.collaborationBenefits },
    { label: '협업비용', value: totals?.collaborationCost },
    { label: totals?.calcStatus === 'before' ? '예상 매출 이익' : '최종 매출이익', value: totals?.finalSalesProfit },
    { label: totals?.calcStatus === 'before' ? '예상 매출 이익률' : '최종 매출이익률', value: totals?.salesProfitMargin, isPercent: true },
  ];

  // 모바일용 접이식(Accordion) 레이아웃
  if (isMobile) {
  return (
    <>
      {/* 첫 번째 줄: 수익 요약 아코디언 박스 */}
      <Box sx={{ width: '100%', mb: 1 , mt: 1}}>
        <Accordion 
          sx={{ 
            backgroundColor: 'background.paper',
            boxShadow: 'none', 
            border: `1px solid ${theme.palette.divider}`, 
            borderRadius: '4px !important',
            '&:before': { display: 'none' } 
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle2" sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
              수익 요약 정보 (총매출: {getNumberComma(totals?.sales)})
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <Stack spacing={1}>
              {summaryData.map((item, index) => (
                <Box 
                  key={index} 
                  sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    borderBottom: index !== summaryData.length - 1 ? '1px dashed #eee' : 'none', 
                    pb: 0.5 
                  }}
                >
                  <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>{item.label}</Typography>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold' }}>
                    {getNumberComma(item.value)}{item.isPercent ? ' %' : ''}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Box>

      {/* 두 번째 줄: 버튼 전용 박스 */}
      {isForeCast && (
        <Box sx={{ width: '100%', mb: 2 }}>
          <Button 
            fullWidth
            variant="contained" 
            color="secondary" 
            onClick={handleAddForecast}
            sx={{ 
              py: 1.2, 
              fontWeight: 'bold',
              fontSize: '0.85rem'
            }}
          >
            포캐스팅 추가
          </Button>
        </Box>
      )}
    </>
  );
}


  // 데스크탑 레이아웃 (기존 유지)
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      flexWrap: 'wrap', // 모바일에서 공간 부족 시 자동 줄바꿈
      gap: 1, 
      my: 2, 
      px: 1 ,
      height: isMobile ? 'auto' :'40px'
    }}>
      {/* 왼쪽: 요약 데이터 영역 */}
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
        sx={{ flexWrap: 'wrap' }} // 데이터가 많을 경우 대비
      >
        {summaryData.map((item, index) => (
          <Stack key={index} direction="row" spacing={1} alignItems="center">
            <Typography variant="body2">{item.label}:</Typography>
            {/* fontWeight 제거하여 원래 subtitle2 스타일로 복구 */}
            <Typography variant="subtitle2">
              {item.isPercent 
                ? item.value 
                : getNumberComma(item.value)
              }
              {item.isPercent ? ' %' : ''}
            </Typography>
          </Stack>
        ))}
      </Stack>

      {/* 오른쪽: 버튼 영역 */}
      {isForeCast && (
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={handleAddForecast} 
          sx={{ 
            whiteSpace: 'nowrap', 
            ml: 'auto', // 모바일에서는 마진 제거
            height: 'fit-content', 
            fontSize: '0.90rem', // 글자 크기 추가 축소
            padding: '4px 8px',   // 내부 여백 조정
            minWidth: 'auto'      // 최소 너비 해제
          }}
        >
          포캐스팅 추가
        </Button>
      )}
    </Box>
  );
};

export default ChanceTotalSummary;
